import instoreAddNewCardModal from './instoreSMSNumberModal';

export default instoreAddNewCardModal;
